export const normalizeCanonicalPath = (url: string): string => {
  try {
    const parsedUrl = new URL(url);

    // Homepage
    if (parsedUrl.pathname === "/") {
      return parsedUrl.origin + "/";
    }

    // Remove existing trailing slashes
    const cleanPath = parsedUrl.pathname.replace(/\/+$/, "");

    return `${parsedUrl.origin}${cleanPath}/`;
  } catch {
    return url;
  }
};

export const normalizeInternalPath = (pathname: string): string => {
  const publicRoutePrefixes = [
    "/about",
    "/basket",
    "/blog",
    "/checkout",
    "/contact",
    "/family-session",
    "/gallery",
    "/newborn-session",
    "/order-success",
    "/prices",
    "/resources",
    "/session-information",
  ];
  const isPublicRoute = publicRoutePrefixes.some(
    (routePrefix) => pathname === routePrefix || pathname.startsWith(`${routePrefix}/`)
  );

  if (!isPublicRoute || pathname.endsWith("/") || /\/[^/]+\.[^/]+$/.test(pathname)) {
    return pathname;
  }

  return `${pathname}/`;
};

export const charlottePhotographyServiceAreas = [
  { "@type": "City", name: "Charlotte, NC" },
  { "@type": "AdministrativeArea", name: "Charlotte metropolitan area" },
  { "@type": "AdministrativeArea", name: "Lake Norman, NC" },
  { "@type": "AdministrativeArea", name: "Union County, NC" },
  { "@type": "AdministrativeArea", name: "York County, SC" },
  { "@type": "Place", name: "Ballantyne, Charlotte, NC" },
  { "@type": "City", name: "Matthews, NC" },
  { "@type": "City", name: "Huntersville, NC" },
  { "@type": "City", name: "Concord, NC" },
  { "@type": "Place", name: "Indian Land, SC" },
  { "@type": "City", name: "Fort Mill, SC" },
  { "@type": "City", name: "Rock Hill, SC" },
] as const;
